var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"hide-breadcrumbs":"","no-header":"","fluid":"","loading":_vm.Loading}},[_c('FilterSchoolSearch',{attrs:{"enabled":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }